import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    open: Boolean
  }

  connect() {
    requestAnimationFrame(() => {
      this.element.dataset.open = true
    });
  }

  close() {
    this.element.dataset.open = false

    setTimeout(() => {
      const turboFrame = this.element.closest("turbo-frame");
      if (turboFrame) {
        turboFrame.removeAttribute("src");
        turboFrame.removeAttribute("complete");
      }

      this.element.remove();
    }, 300);
  }
}
